import type { ConceptDef } from '../types';

export const mandPictures: ConceptDef = {
  kind: 'supervisorScored',
  id: 'mand-pictures',
  label: 'Mand Pictures',
  category: 'Mand',
  description: 'Show a desired item; learner requests it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🧃 juice', hint: 'Learner requests: "juice"' },
      { prompt: '🍪 cookie', hint: 'Learner requests: "cookie"' },
      { prompt: '⚽ ball', hint: 'Learner requests: "ball"' },
      { prompt: '🧸 teddy', hint: 'Learner requests: "teddy"' },
      { prompt: '📕 book', hint: 'Learner requests: "book"' },
      { prompt: '🥛 milk', hint: 'Learner requests: "milk"' },
    ],
  },
};
